// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2g3UY","error":"Textarea_error__1HocR","readonly":"Textarea_readonly__3B6pI","disabled":"Textarea_disabled__1XYzq"};